const FormReducer = (state, action) => {
  if (action.type === "LASTNAME_INPUT") {
    if (action.value.trim().length > 0) {
      state.error.lastNameError = "";
    } else {
      state.error.lastNameError =
        "This field is required";
    }

    return {
      ...state,
      lastNameValue: action.value,
      lastNameIsValid:
        action.value.trim().length > 0,
    };
  }
  if (action.type === "FIRSTNAME_INPUT") {
    if (action.value.trim().length > 0) {
      state.error.firstNameError = "";
    } else {
      state.error.firstNameError =
        "This field is required";
    }
    return {
      ...state,
      firstNameValue: action.value,
      firstNameIsValid:
        action.value.trim().length > 0,
    };
  }
  if (action.type === "EMAIL_INPUT") {
    if (action.value.trim().length > 0) {
      state.error.emailError = "";
    } else {
      state.error.emailError =
        "This field is required";
    }
    // if (action.emailExistError) {
    //   console.log(action.emailExistError);
    // }
    return {
      ...state,
      emailValue: action.value,
      emailIsValid: action.value.includes("@"),
    };
  }
  if (action.type === "EMAIL_EXIST") {
    if (action.emailExistError) {
      state.error.emailError =
        "email address already exist";
      state.emailIsValid = false;
    } else {
      state.error.emailError = "";
    }
    return {
      ...state,
      emailIsValid: action.value.includes("@"),
    };
  }

  if (action.type === "PASSWORD_INPUT") {
    if (state.confirmPasswordValue) {
      if (
        state.confirmPasswordValue ===
        action.value
      ) {
        state.error.confirmPasswordError = "";
        state.error.passwordError = "";
        state.passwordIsValid = true;
        state.confirmPasswordIsValid = true;
      } else {
        state.error.confirmPasswordError =
          "Password does not match";
        state.error.passwordError =
          "Password does not match";
        state.passwordIsValid = false;
        state.confirmPasswordIsValid = false;
      }
    }

    return {
      ...state,
      passwordValue: action.value,
      passwordIsValid:
        action.value.trim().length >= 6,
    };
  }
  if (action.type === "CONFIRM-PASSWORD_INPUT") {
    if (state.passwordValue === action.value) {
      state.error.confirmPasswordError = "";
      state.error.passwordError = "";
      state.passwordIsValid = true;
    } else {
      state.error.confirmPasswordError =
        "Password does not match";
      state.passwordIsValid = false;
    }
    return {
      ...state,
      confirmPasswordValue: action.value,
      confirmPasswordIsValid:
        action.value.trim() ===
          state.passwordValue &&
        action.value.trim().length > 6,
    };
  }

  if (action.type === "FORM_SUBMIT") {
    const {
      lastName,
      firstName,
      emailAddress,
      password,
      confirmPassword,
    } = action.values;
    if (lastName.trim().length === 0) {
      state.error.lastNameError =
        "This field is required";
    } else {
      state.error.lastNameError = "";
    }
    if (firstName.trim().length === 0) {
      state.error.firstNameError =
        "This field is required";
    } else {
      state.error.firstNameError = "";
    }
    if (emailAddress.trim().length === 0) {
      state.error.emailError =
        "This field is required";
    } else {
      state.error.emailError = "";
    }
    if (password.trim().length === 0) {
      state.error.passwordError =
        "This field is required";
    } else {
      state.error.passwordError = "";
    }
    if (confirmPassword.trim().length === 0) {
      state.error.confirmPasswordError =
        "This field is required";
    } else {
      state.error.confirmPasswordError = "";
    }

    return { ...state };
  }
  if (action.type === "FORM_VALIDITY") {
    return {
      ...state,
      formIsValid:
        state.emailIsValid &&
        state.passwordIsValid,
    };
  }

  if (action.type === "RESET") {
    state.error.lastNameError = "";
    state.error.firstNameError = "";
    state.error.emailError = "";
    state.error.passwordError = "";
    state.error.confirmPasswordError = "";
    return {
      ...state,
    };
  }
  if (action.type === "EMAIL_EXIST_RESET") {
    state.error.emailError = "";
    state.emailIsValid = false;

    return {
      ...state,
    };
  }

  throw new Error("action type invalid");
};

export default FormReducer;
